import { createSwiper } from './swiper';

const initTestimonials = (section) => {
  const carousel = section.querySelector('.testimonials__carousel');
  if (!carousel || carousel.swiper) return;

  return createSwiper(carousel, {
    lazy: true,
    slidesPerView: 'auto',
    spaceBetween: 16,
    slideClass: 'swiper__col',
    wrapperClass: 'swiper__row',
    navigation: {
      nextEl: carousel.querySelector('.testimonials__nav-btn--next'),
      prevEl: carousel.querySelector('.testimonials__nav-btn--prev'),
    },
    pagination: {
      el: carousel.querySelector('.testimonials__pagination'),
      clickable: true,
    },
    a11y: { enabled: true },
  });
};

const testimonials = () => {
  document.querySelectorAll('.testimonials').forEach(initTestimonials);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.testimonials');
    if (section) initTestimonials(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const carousel = e.target.querySelector('.testimonials__carousel');
    if (carousel?.swiper) carousel.swiper.destroy(true, true);
  });

  document.addEventListener('shopify:block:select', (e) => {
    const carousel = e.target.closest('.testimonials__carousel');
    if (!carousel?.swiper) return;
    const slide = e.target.closest('.swiper__col');
    if (!slide) return;
    const index = Array.from(carousel.querySelectorAll('.swiper__col')).indexOf(slide);
    if (index >= 0) carousel.swiper.slideTo(index);
  });
};

export default testimonials;
